// extracted by mini-css-extract-plugin
export default {"mt20":"index_mt20_y3bxY"};